import { Col, Row } from "react-bootstrap"
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory from 'react-bootstrap-table2-editor';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';

function CatTable({columns, items, noEdit}){
    const { SearchBar } = Search;

    return (
        <Row>
            <Col>
            <ToolkitProvider
                keyField="id"
                data={ items }
                columns={ columns }
                search
                >
                {
                    props => (
                    <div>
                        
                        <SearchBar { ...props.searchProps } 
                            placeholder ="Buscar"
                            className="input-search"
                        />
                        <hr />
                        <BootstrapTable 
                        { ...props.baseProps }
                            keyField='id' 
                            data={ items } 
                            columns={ columns } 
                            bordered={false}
                            classes="border-top-0 simple-table"
                            wrapperClasses="table-responsive-md"
                            noDataIndication="No hay información disponible"
                            cellEdit={
                                noEdit ? {} :
                                cellEditFactory({ 
                                    mode: "click",
                                    blurToSave: true
                                })
                            }
                            pagination={ paginationFactory() }
                        />
                    </div>
                    )
                }
            </ToolkitProvider>
            </Col>
        </Row>
    )

}

export default CatTable